module.exports = __webpack_public_path__ + "static/media/1.fc569f25.jpg";